// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_8p-4";
export var collapsed = "_8p-1";
export var headerBar = "_8p-0";
export var leftHeaderContent = "_8p-3";
export var subjectContainer = "_8p-2";